import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOPatientRiskFactor } from "../models/BOPatientRiskFactor.model";
import { BOTransPatientRiskFactor } from "../models/auxiliars/BOTranspPatientRiskFactor.model";

@Injectable({
  providedIn: 'root'
}

)
export class PatientRiskFactorService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/PatientRiskFactor/';

    constructor(private http:HttpClient){}
  // #region First

    getAllByPatientId(patientId:number):Observable<BOPatientRiskFactor[]>{
        return this.http.get<BOPatientRiskFactor[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    createOrUpdatePatientRiskFactor(transp:BOTransPatientRiskFactor):Observable<BOPatientRiskFactor[]>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BOPatientRiskFactor[]>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientRiskFactor',body,httpOptions);
    }
//#endregion First

//#region Single
  createOrUpdatePatientRiskFactorSingle(patientId:number, disease:BOPatientRiskFactor):Observable<BOPatientRiskFactor>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOPatientRiskFactor>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientRiskFactorSingle/' + patientId,body,httpOptions);
  }

  deletePatientRiskFactorSingle(id:number):Observable<BOPatientRiskFactor>
  {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOPatientRiskFactor>(this.myAppUrl + this.myApiUrl + 'deletePatientRiskFactorSingle/' + id,null,httpOptions);
    }


//#endregion Single

}
